module.exports = __webpack_public_path__ + "assets/img/8.c40d7e1a.png";